import * as React from 'react'

export type RootProps = {
  children: React.ReactNode
}

export const Root = ({ children }: RootProps) => (
  <div className="flex-1 overflow-hidden">{children}</div>
)
